import { IClientTripFull } from '@bustickus/models-client';
import { Box, Flex, Header } from 'components';
import { TripInfo, TripPath, TripPathTime } from './components';
import './style.scss';

interface IProps {
  trip: IClientTripFull;
  departureCityId: string | null | undefined;
  arrivalCityId: string | null | undefined;
}

function TripCard(props: IProps) {
  return (
    <Box padding={20}>
      <Flex
        direction='column'
        gap={20}
      >
        <Flex
          justifyContent='space-between'
          alignItems='flex-end'
          gap={10}
        >
          <Header className='trip-card-header-jkUnV'>Билет на рейс</Header>
          <span className='trip-carrier-name-Rxr9'>{props.trip.carrierName}</span>
        </Flex>

        <TripPath
          trip={props.trip}
          departureCityId={props.departureCityId}
          arrivalCityId={props.arrivalCityId}
        />

        <TripPathTime
          points={props.trip.points}
          departureCityId={props.departureCityId}
          arrivalCityId={props.arrivalCityId}
        />

        <TripInfo trip={props.trip} />
      </Flex>
    </Box>
  );
}

export default TripCard;
